export type AccountLockMeta = {
  lockedAt: string;
  lockedBy: "ad_campaign" | "social_post";
};

export type AdsAccountLock = AccountLockMeta & {
  accountId: string;
  accountName?: string;
};

export type SocialIdentityLock = AccountLockMeta & {
  pageId?: string;
  pageName?: string;
  instaAccId?: string;
  instaUsername?: string;
  openId?: string;
  postingOrganizationId?: string;
  postingPreference?: "PERSONAL" | "COMPANY";
  channelId?: string;
  email?: string;
  displayName?: string;
};

export type AdsLockPlatformKey =
  | "facebookAds"
  | "googleAdwords"
  | "linkedinAds"
  | "tiktokAds"
  | "snapchatAds"
  | "bingAds"
  | "spotifyAds"
  | "openAiAds";

export type SocialLockPlatformKey =
  | "facebook"
  | "instagram"
  | "linkedin"
  | "tiktok"
  | "youtube";

export type AccountLocks = {
  ads?: Partial<Record<AdsLockPlatformKey, AdsAccountLock>>;
  social?: Partial<Record<SocialLockPlatformKey, SocialIdentityLock>>;
};

export const ACCOUNT_LOCK_MESSAGE =
  "This workspace is permanently linked to this account. After reconnecting an expired session you must use the same account. To use a different account, create a new workspace.";

export const getLockedAccountMessage = (name?: string) =>
  name
    ? `This workspace is permanently linked to ${name}. After reconnecting an expired session you must use the same account. To use a different account, create a new workspace.`
    : ACCOUNT_LOCK_MESSAGE;
